import React, { Component } from 'react';
import Notificacao from '../Notificacao';
import moment from 'moment';
import { getCidadebyId } from '../../Libs/cidade';

import logo from '../../assets/images/logo-global-brain.png'
import HeaderModal from '../../gb-components/HeaderModal';
import PrintTemplate from 'react-print';
export default class Cirurgia extends Component {
  state = {
    comentario: '',
    ref: null,
    alertMsg: null,
    status: null,
    openModal: false,
    cidade: '',
    paciente: null,
    NomeCidade: ''
  };
  componentDidMount() {
    getCidadebyId(this.props.item.profissional.cidade).then(cidade => {
      this.setState({ NomeCidade: cidade.cidade });
    });
  }
  // componentDidMount(){
  //   getCidadebyId(this.props.item.profissional.cidade)
  //   .then(cidade => {
  //    this.setState({NomeCidade: cidade.cidade})
  //  }
  // }
  _setImprimir = () => {
    window.print();
  };
  render() {
    
    return (
      <div>

            
        
        <PrintTemplate>
            <center>
            <img src={logo} alt="" height="70" />
             
              <h4>{`${this.state.NomeCidade}`}</h4>
            </center>
            {/* <br />
            {this.props.item.receita.remedio_1 ? 
            <p>{`Primeiro Remédio: ${this.props.item.receita.remedio_1}`}</p>
           : null }
           {this.props.item.receita.prescricao_1 ?
            <p>{`Primeira Prescrição: ${this.props.item.receita.prescricao_1}`}</p>
          : null } 
          {this.props.item.receita.remedio_2 ? 
            <p>{`Segundo Remédio: ${this.props.item.receita.remedio_2}`}</p>
            : null }
{this.props.item.receita.prescricao_2 ?
            <p>{`Segunda Prescrição: ${this.props.item.receita.prescricao_2}`}</p>
            : null }
            {this.props.item.receita.remedio_3 ?
            <p>{`Terceiro Remédio: ${this.props.item.receita.remedio_3}`}</p>
            : null }
            {this.props.item.receita.prescricao_3 ?
            <p>{`Terceira Prescrição: ${this.props.item.receita.prescricao_3}`}</p>
           : null }
           {this.props.item.receita.remedio_4 ?
            <p>{`Quarto Remédio: ${this.props.item.receita.remedio_4}`}</p>
            : null }
            {this.props.item.receita.prescricao_4 ? 
            <p>{`Quarta Prescrição: ${this.props.item.receita.prescricao_4}`}</p>
            : null} */}
              {/* <strong>Cidade:</strong>{this.state.NomeCidade}
              <br/> */}
              <br />
              {this.props.item.receita.remedio_1 ? (
                <p><strong>1º Remédio:</strong> {this.props.item.receita.remedio_1}</p>
              ) : null}
              {this.props.item.receita.prescricao_1 ? (
                <p><strong>1ª Prescrição:</strong> {this.props.item.receita.prescricao_1}</p>
              ) : null}
              {this.props.item.receita.remedio_2 ? (
                <p><strong>2º Remédio:</strong> {this.props.item.receita.remedio_2}</p>
              ) : null}
              {this.props.item.receita.prescricao_2 ? (
                <p><strong>2ª Prescrição:</strong> {this.props.item.receita.prescricao_2}</p>
              ) : null}
              {this.props.item.receita.remedio_3 ? (
                <p><strong>3º Remédio:</strong> {this.props.item.receita.remedio_3}</p>
              ) : null}
              {this.props.item.receita.prescricao_3 ? (
                <p><strong>3ª Prescrição:</strong> {this.props.item.receita.prescricao_3}</p>
              ) : null}
              {this.props.item.receita.remedio_4 ? (
                <p><strong>4º Remédio:</strong> {this.props.item.receita.remedio_4}</p>
              ) : null}
              {this.props.item.receita.prescricao_4 ? (
                <p><strong>4ª Prescrição:</strong> {this.props.item.receita.prescricao_4}</p>
              ) : null}
            

            
            <strong>
              <p>
                <br />
                {moment(
                  this.props.item.receita.DataCriacao,
                  'DD-MM-YYYY'
                ).format('DD/MM/YYYY')}
              </p>
              <p>{this.props.item.profissional.nome}<br />
            {`CRM: ${this.props.item.profissional.crm}`}</p>
            </strong>
          

        
        </PrintTemplate>

             
      
        <div
          id="react-no-print"
          // className="container"
          // style={{
          //   overflowY: 'scroll',
          //   overflowX: 'hidden',
          //   maxHeight: '80vh'
          // }}
        >
        
          <HeaderModal title="Receita"/>

          <div className="col">
            
            <strong>Cidade: </strong>{this.state.NomeCidade}
            <br/>
            <br />
            {this.props.item.receita.remedio_1 ? (
              <p><strong>1º Remédio:</strong> {this.props.item.receita.remedio_1}</p>
            ) : null}
            {this.props.item.receita.prescricao_1 ? (
              <p><strong>1ª Prescrição:</strong> {this.props.item.receita.prescricao_1}</p>
            ) : null}
            {this.props.item.receita.remedio_2 ? (
              <p><strong>2º Remédio:</strong> {this.props.item.receita.remedio_2}</p>
            ) : null}
            {this.props.item.receita.prescricao_2 ? (
              <p><strong>2ª Prescrição:</strong> {this.props.item.receita.prescricao_2}</p>
            ) : null}
            {this.props.item.receita.remedio_3 ? (
              <p><strong>3º Remédio:</strong> {this.props.item.receita.remedio_3}</p>
            ) : null}
            {this.props.item.receita.prescricao_3 ? (
              <p><strong>3ª Prescrição:</strong> {this.props.item.receita.prescricao_3}</p>
            ) : null}
            {this.props.item.receita.remedio_4 ? (
              <p><strong>4º Remédio:</strong> {this.props.item.receita.remedio_4}</p>
            ) : null}
            {this.props.item.receita.prescricao_4 ? (
              <p><strong>4ª Prescrição:</strong> {this.props.item.receita.prescricao_4}</p>
            ) : null}


            
              <strong>
                <p>
                  <br />
                  {moment(
                    this.props.item.receita.DataCriacao,
                    'DD-MM-YYYY'
                  ).format('DD/MM/YYYY')}
                </p>
                <p>{this.props.item.profissional.nome}<br />
                {`CRM: ${this.props.item.profissional.crm}`}</p>
              </strong>
            
          </div>
          <br />
   
      
        {this.state.notifition ? (
            <Notificacao
              msg={this.state.msg}
              nameclass={this.state.nameclass}
            />
          ) : null}
         <div>
              <br />
              <button
                style={{ float: 'right' }}
                onClick={() => this._setImprimir()}
                type="button"
                className="btn gb-button to-form right"
              >
                Imprimir
              </button>
              <br />
          </div>

          
        </div>    
      </div>
    );
  }
}
